import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";
import {ApiToolsService} from '../services/api-tools.service';
import {AnalyticsService} from "../services/analytics.service";
import {Batiment} from '../Models/Batiment';
import {specialCompaniesParcours} from '../const/utils';
import * as _ from 'lodash';
import {ROUTES_PATHS} from "../const/routes";
import {RENOVATION_VALUE_MAP} from "../const/renovation-type";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Component({
	selector: 'app-pieces',
	templateUrl: './pieces.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./pieces.component.less']
})
export class PiecesComponent implements OnInit {
	optsTypePiece: any;
	//fctPercentPiece: any;
	textes: any = "";
	globalTxt: any = "";
	modalsTxt: any = "";
	//bien: any;
	srfUtilise = 0;
	srfRestant: any;
	isTrial: any;
	showButtonAdd = true;
	renovationValue: number = -1;
	newPiece: any = {
		id: null,
		type: null,
		surface: null,
	}

	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	token = JSON.parse(localStorage.getItem("token")!);
	arrPieces: any = [];

	constructor(
		public app: AppComponent,
		public apiToolsService: ApiToolsService,
		public analyticsService: AnalyticsService
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		let renovation: any = localStorage.getItem("RENOVATION");
		this.renovationValue = this.app.sharedToolsService.getRenovationValue(renovation);
		console.log("renovationValue: ", this.renovationValue);

		// Delete the modalOpen from localStorage to avoid problems
		if (localStorage.getItem("modalOpen") != null) localStorage.removeItem("modalOpen");

		// Get the modal texts
		this.app.dataInitService.getModalTextsOnce(modalsTxt => {
			this.modalsTxt = modalsTxt;
		});

		// Get the options for the type of piece
		this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
			this.optsTypePiece = cloneDeep(opts.optsTypePiece);
		});

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
		this.app.dataToolsService.currentIsTrial.subscribe(resp => {
			this.isTrial = resp;
			console.log('update this.isTrial => ', this.isTrial);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get Simulation params by batiment.simulationId
		this.getSinistreByID();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;
				});
		});
	}

	getSinistreByID() {
		this.apiToolsService.getSinistreByID(parseInt(this.batiment.simulationId!), true).subscribe(res => {
			console.log("res getSinistreByID ==> ", res);

			let arrPiecesTemp = (_.isArray(res)) ? _.cloneDeep(res) : [];

			let total = 0;
			for (var i = 0; i < arrPiecesTemp.length; i++) {
				total = _.filter(arrPiecesTemp, function (obj) {
					return obj.type == arrPiecesTemp[i].type;
				}).length;
				arrPiecesTemp[i].numPic = (total > 1) ? arrPiecesTemp[i].count : '';
				if (!isNaN(arrPiecesTemp[i].surface)) arrPiecesTemp[i].surface = Math.round(arrPiecesTemp[i].surface);
			}

			this.arrPieces = arrPiecesTemp;

			if (this.arrPieces && this.arrPieces.length > 0) {
				this.arrPieces.forEach((pic: any) => {
					pic.isDefinitelyAdded = true;
				})

				// ==> Call function Calcul
				this.calculSrfTotalEtRestant(this.batiment.surface);
			}
		});
	}

	//getObjectsByTypeBien(_typeBien: any, _nbPieces: any) {
	//  return this.fctPercentPiece.filter((obj: any) => {
	//    return (obj.typeBien == _typeBien && obj.nbPieces == _nbPieces);
	//  });
	//}

	groupByKey(array: any, key: any) {
		return array
			.reduce((hash: any, obj: any) => {
				if (!obj[key]) return hash;
				return Object.assign(hash, {[obj[key]]: (hash[obj[key]] || []).concat(obj)})
			}, {})
	}

	getLabelAndIdPieceByType(_piece: any) {
		// ==> On prends le label et l'id de la piece qu'on est en train de rajouter
		console.log("_piece ==> ", _piece);
		//console.log("this.optsTypePiece ==> ", this.optsTypePiece);

		if (!this.optsTypePiece) {
			this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
				this.optsTypePiece = cloneDeep(opts.optsTypePiece);
				if (_piece.type) _piece.label = this.app.sharedToolsService.getLabel(_piece.type, this.optsTypePiece);
			});
		} else {
			if (_piece.type) _piece.label = this.app.sharedToolsService.getLabel(_piece.type, this.optsTypePiece);
		}

		//console.log("_piece ==> ", _piece);

		// ==> On cree un objet avec des array selon le type pour verifier s'il y a plus de un et changer ensuite le label en rajoutant le number
		let arraysFromArrayPieces = this.groupByKey(this.arrPieces, 'type');

		for (const [key, value] of Object.entries(arraysFromArrayPieces)) {
			let valueArray: any = value;

			if (valueArray.length > 0) {
				valueArray.forEach((k: any, index: any) => {
					// S'il n'existe pas on le met à chaîne vide
					k.count = (!k.count) ? "" : k.count;
					k.numPic = (!k.numPic) ? "" : k.numPic;
					// ==> S'il y en a plus de 2 alors on met la numérotation dans tous
					if (valueArray.length > 1) {
						k.count = index + 1;
						k.numPic = index + 1;
					}
				});
			}
		}
	}

	calculSrfTotalEtRestant(_bienSrf: any) {
		// ==> On remets la surface utilisé à 0
		this.srfUtilise = 0;

		// ==> On recalcule les surfaces totale et restant
		this.arrPieces.forEach((k: any) => {
			if (k.type != -1) {
				k.surface = +k.surface;
				this.srfUtilise += k.surface;
			}
		});

		let srfRestantTemp = _bienSrf - this.srfUtilise;
		this.srfRestant = Math.round(srfRestantTemp * 100) / 100;
	}

	addNewPiece() {
		let newPiece = cloneDeep(this.newPiece)
		this.arrPieces.push(newPiece);

		this.getIfShowBtnAdd();
	}

	getIfShowBtnAdd() {
		let arrPiecesHasIdNull: any;
		console.log("this.arrPieces ==> ", this.arrPieces);

		arrPiecesHasIdNull = this.arrPieces.filter((pic: any) => {
			return ((!pic.type || !pic.surface) && (pic.type != -1));
		});

		console.log("arrPiecesHasIdNull ==> ", arrPiecesHasIdNull);

		this.showButtonAdd = (arrPiecesHasIdNull.length > 0) ? false : true;
		console.log("this.showButtonAdd ==> ", this.showButtonAdd);

	}

	onDeletePiece(_piece: any) {
		//console.log(this.arrayUsersCtc)
		this.app.confirmDialogService.confirmThis(
			"", //title
			this.modalsTxt.modalSupp, //text
			"confirm", //type
			"suppression", //template
			() => {
				let indexPicToDelete = this.arrPieces.findIndex((o: any) => o.id == _piece.id);
				if (indexPicToDelete !== -1)
					this.arrPieces.splice(indexPicToDelete, 1);

				// ==>
				let arraysFromArrayPieces = this.groupByKey(this.arrPieces, 'type');

				console.log("arraysFromArrayPieces ==> ", arraysFromArrayPieces)

				for (const [key, value] of Object.entries(arraysFromArrayPieces)) {
					let valueArray: any = value;

					if (valueArray.length > 0) {
						valueArray.forEach((k: any, index: any) => {
							// ==> S'il n'existe pas on le met à chaîne vide
							k.count = (!k.count) ? "" : index + 1;
							k.numPic = (!k.numPic) ? "" : index + 1;
							// ==> S'il y en a plus de 2 alors on met la numérotation dans tous
							if (valueArray.length > 1) {
								k.count = index + 1;
								k.numPic = index + 1;
							}
						});
					}
				}

				this.calculSrfTotalEtRestant(this.batiment.surface); //this.bien.srf

			},
			() => {
				return;
			}
		)
	}

	onAddNewPiece(_piece: any) {
		_piece.typeErrorMsg = (!_piece.type) ? true : false;
		_piece.srfErrorMsg = (!_piece.surface || _piece.surface == 0) ? true : false;
		_piece.isDefinitelyAdded = false;

		console.log("_piece.type ==> ", _piece.type);
		console.log("_piece.surface ==> ", _piece.surface);

		// ==> Les deux champs sont obligatoires
		if (!_piece.type || !_piece.surface) {
			return;
		}

		_piece.isDefinitelyAdded = true;

		// ==> On affiche ou pas le bouton Ajouter une pièce
		this.getIfShowBtnAdd();

		// ==> On change les libelles et les id
		this.getLabelAndIdPieceByType(_piece);
		this.calculSrfTotalEtRestant(this.batiment.surface);
	}

	getErrorMsg(_piece: any, _param: any) {
		if (_param == "type") _piece.typeErrorMsg = (!_piece.type) ? true : false;
		if (_param == "surface") _piece.srfErrorMsg = (!_piece.surface || _piece.surface == 0) ? true : false;
	}

	onChangeTypePiece(_pic: any) {
		this.getErrorMsg(_pic, "type");
	}

	onKeyUp(_pic: any, _event: any) {
		this.getErrorMsg(_pic, "surface");

		if (!_pic.surface || _pic.surface == 0) {
			return;
		}

		_pic.surface = Math.round(_pic.surface);

		if (_pic.id != null) this.calculSrfTotalEtRestant(this.batiment.surface); //this.bien.srf
	}

	private updateSurface(_pic: any, delta: number) {
		const newSurface = +(Number(_pic.surface) + delta);
		if (newSurface <= 0) {
			this.getErrorMsg(_pic, "surface");
			return;
		}
		_pic.surface = newSurface.toFixed(2);
		console.log("_pic.surface: ", _pic.surface);
		this.getErrorMsg(_pic, "surface");

		if (_pic.id != null) this.calculSrfTotalEtRestant(this.batiment.surface);
	}

	getMinusAlt(_pic: any) {
		this.updateSurface(_pic, -1);
	}

	getPlusAlt(_pic: any) {
		this.updateSurface(_pic, 1);
	}

	/** * @deprecated Use getMinusAlt and getPlusAlt instead */
	// getMinusAlt(_pic: any) {
	// 	_pic.surface--
	// 	_pic.surface = _pic.surface.toFixed(2);
	// 	console.log("picsurface---->", _pic.surface)
	// 	this.getErrorMsg(_pic, "surface");
	//
	// 	if (!_pic.surface || _pic.surface == 0) {
	// 		return;
	// 	}
	//
	// 	// _pic.surface = Math.round(_pic.surface);
	//
	// 	if (_pic.id != null) this.calculSrfTotalEtRestant(this.batiment.surface); //this.bien.srf
	// }
	//
	// getPlusAlt(_pic: any) {
	// 	// console.log("pic---->", _pic)
	// 	// _pic.surface = _pic.surface++;
	// 	_pic.surface++
	// 	console.log("_pic.surface", _pic.surface)
	// 	_pic.surface = _pic.surface.toFixed(2);
	// 	this.getErrorMsg(_pic, "surface");
	//
	// 	if (!_pic.surface || _pic.surface == 0) {
	// 		return;
	// 	}
	// 	// _pic.surface = Math.round(_pic.surface);
	// 	if (_pic.id != null) this.calculSrfTotalEtRestant(this.batiment.surface); //this.bien.srf
	// }

	public onChangeDoIsolation(event: any, pic: any) {
		console.log(event.target.checked, pic.doIsolation);
	}

	public onSubmit() {
		let arrPiecesIdNotComplete: any = this.arrPieces.filter((pic: any) => {
			return pic.type != -1 && (!pic.type || !pic.surface);
		});
		console.log("arrPiecesIdNotComplete ==> ", arrPiecesIdNotComplete);

		let msgAlert = (arrPiecesIdNotComplete.length > 0) ? this.modalsTxt.modalFormIncomplet : (this.srfRestant < 0) ? this.modalsTxt.modalFormPiecesNotValid : "";
		let typeAlert = (arrPiecesIdNotComplete.length > 0) ? "alert" : (this.srfRestant < 0) ? "confirm" : "";

		if (arrPiecesIdNotComplete.length > 0 || this.srfRestant < 0) {
			arrPiecesIdNotComplete.forEach((_pic: any) => {
				this.getErrorMsg(_pic, "surface");
				this.getErrorMsg(_pic, "type");
			});

			this.app.confirmDialogService.confirmThis("", msgAlert, typeAlert, "", () => {
				if (typeAlert == "confirm") {
					this.updateSimulation();
				}
			}, () => {
				return;
			});

			console.log("this.arrPieces ==> ", this.arrPieces);
			return;
		} else {
			console.log("this.arrPieces ==> ", this.arrPieces);
			this.updateSimulation();
		}
	}

	updateSimulation() {
		this.app.apiToolsService.simulationPieceMinUpdate(this.arrPieces, parseInt(this.batiment.simulationId!)).subscribe(res => {
			console.log("res", res);

			if (res != "OK") {
				this.app.confirmDialogService.confirmThis("", "Une erreur s'est produite !", "alert", "", () => {
				}, () => {
				});
				return;
			}

			// Tracking Analytics : Pièces
			this.analyticsService.trackEvent('user_interaction', 'click_pieces', 'value : ' + (this.arrPieces.length - 1) + ' pièces');

			// ==> On save les Pieces dans le localStorage, mais ce serait mieux de les recuperer par un service dans l'init de la page Suivante
			localStorage.setItem('arrPieces', JSON.stringify(this.arrPieces));

			// ==> If the user is from SeLoger, then a new registration modal is displayed.
			// On récupère le token pour savoir si c'est un user de SeLoger, LfImmo, Arthurimmo ou WeInvestClient

			if (specialCompaniesParcours.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) != -1
				|| this.app.sharedToolsService.returnObjectSwitchRefId() === SiteKeyEnum.KOUTRAVOFREE) {
				let modal: any = {
					name: "modal-inscription-special",
					isModalImgSpecial: false,
					pathBtnSuivant: this.app.sharedToolsService.getRoutePath(this.textes.pathBtnSuivant),//this.textes.pathBtnSuivant,
					data: {}
				}

				localStorage.setItem('modalOpen', JSON.stringify(modal));

				//Open modal
				this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
				}, () => {
				});
				return;
			}
			// ==> Generation Chiffrage et Mobilier
			this.app.apiToolsService.generationSurfaceEtMobilierSimulation(parseInt(this.batiment.simulationId!)).subscribe(reponse => {
				console.log("res generationSurfaceEtMobilierSimulation", reponse);
				// KTV_EXTERNAL referential goes to the contact form instead of the estimation
				if (this.isTrial) {
					this.app.router.navigate([ROUTES_PATHS.CONTACT_EXTERNE]);
					return;
				}
				// Si le refId ne se trouve pas dans la liste specialCompaniesParcours alors on fait la redirection normale
				// ==> On ouvre la modal de chargement et on redirige vers la page suivante
				this.openModalLoaderEstimation();
			});

		});
	}

	openModalLoaderEstimation() {
		let dataModal: any = {
			calculBareme: 78,
			calculAlgoSrf: "84,32 m",
			calculAlgoPresta: "Appartement "
		}

		let modal: any = {
			name: "modal-loader-estimation",
			isModalImgSpecial: true,
			pathBtnSuivant: this.app.sharedToolsService.getRoutePath(this.textes.pathBtnSuivant),//this.textes.pathBtnSuivant,
			data: dataModal
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			//localStorage.removeItem("modalOpen");
			console.log("No clicked");
			this.app.router.navigate([ROUTES_PATHS.ESTIMATION_RAPIDE])
		})
	}

	public readonly RENOVATION_VALUE_MAP = RENOVATION_VALUE_MAP;
}
